import { render } from "./index.vue?vue&type=template&id=31504d14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=31504d14&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_xMds/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31504d14"]])

export default __exports__